import { initGraphQLTada } from 'gql.tada';

import { introspection } from './omsAdminApi-generated';

/**
 * Creates a typed GraphQL document for the OMS Admin API.
 * Note: this function needs to be named "graphql" to be recognized by the gql.tada ts-plugin.
 *
 * @see https://gql-tada.0no.co/guides/multiple-schemas#_2-initializing-gql-tada-per-schema
 */
export const graphql = initGraphQLTada<{
  introspection: introspection;
  // Masking is disabled in order to avoid mixing the data layer into the UI layer (to avoid tightly coupling graphql with
  // our Vue code). This will make it easier to switch to a different GraphQL client in the future or even to replace GraphQL
  // with REST APIs without needing to change the UI/Vue code.
  disableMasking: true;
  scalars: {
    DateTime: string;
    Money: number;
    JSON: object;
  };
}>();
